import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(({ spacing, palette }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
    backgroundColor: palette.secondary.lighter,
    overflow: 'scroll',
    padding: spacing(1, 2, 0),
  },
  title: {
    fontSize: 14,
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%',
  },
  content: {
    flexGrow: 1,
  },
  editCard: {
    display: 'none',
  },
}));
